import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    FETCH
} from 'one-state-linkincidents/src/types';

import {
    setAction,resetAction
} from 'one-state-linkincidents/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {format} from 'one-util-date';

import { Disposition } from 'one-model-local';
/**
 * This Fuction will intiate linked incidents to
 *  backend api and returns status
 * @param context contains the settings etc..
 */
 export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

export const fetchLinkedIncidentsEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { serverone,agentId, log, settings: { compatible, epicendpoints,servers,uisettings } } = context;
        const { locations = [] } = servers;
        const {  apitoken,linkincident } = epicendpoints;
        const { contact_center_type } = compatible;
        const {
            dashboardapiconfig: {
                linkincident : linkincidentApi
            }
        } = uisettings;
        return action$.pipe(
            ofType(FETCH),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Employee Response
                 */
                
                 let dataresponse:any = action.payload;
                const getRequest = (payload: any) => {
               
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        headers.append("Accept", "application/json");
                        //  todo: delegate to one-server-ha oneview
                        headers.append("Content-Type", "text/plain");
                        const data= {
                            interaction: payload.interaction ? payload.interaction : "",
                            task: payload.task ? payload.task : "",
                            document_table: "incident",
                            sysparm_display_value: true,
                            sysparm_exclude_reference_link: true,
                            sysparm_fields: "task,interaction,type",
                          }
                        const response = serverone.post({
                            path: linkincident,
                            data: data,
                            headers: headers
                        })
                        .then((responsefound: any) => {
                            // treating as success for linked incidents
                            
                            log.debug(
                                "ccw-gadget,linkedincident-epic",
                                "screenpop-epic response", {
                                    responsefound
                            });
                            let result = responsefound;
                            return result;
                        })
                        .catch((responseresult: any) => {
                                 //Check the Side B server receive communication
                      
                            log.error(
                                "ccw-gadget,linkedincident-epic",
                                "screenpop-epic", {
                                responseresult
                            }
                            );
                            let result = responseresult;
                            return result;   
                        })
                    return from(response)

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!linkincidentApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => response)
                    ).
                    pipe(
                        flatMap((response: any) => {
                                const actions:any = [
                                   setAction(response)
                                ];
                                
                                if(response?.errors && response?.errors?.length > 0){
                               /*changes for errors will pushed to bell icon*/
                                    let errorbuild:ErrorObject = {
                                   source: "LinkedIncidents",
                                   type: "error",
                                   status: response?.status,
                                   erroritems: response?.errors,
                                   error_date: errorDate,
                                   error_time: errorTime
                               };
                               actions.push(addAction(errorbuild))
                               let disp: Disposition = { value: "1016" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = response?.error?.status;
                                disp.meta02 = dataresponse.task;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                                }
                                else if (response?.errors?.length  === 0 && (response.status === 500)) {
                                    let disp: Disposition = { value: "1016" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = response?.error?.status;
                                disp.meta02 = dataresponse.task;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                                }
                                else {
                                    let disp: Disposition = { value: "200" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        disp.meta00 = agentIdValue;
                                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                    } else {
                                        disp.meta00 = agentId;
                                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                                    }
                                    disp.meta01 = dataresponse.task;
                                    actions.push(pushToDisposition(disp));
                                }
                               return actions;
                           })
                    )
            })
        )
    }
);


